/* src/app/adhoc-report/adhoc-report.component.scss */
.mat-cell {
  text-align: left;
}
.mat-row {
  border-color: #605959;
}
h2 {
  text-align: right;
  padding-right: 20px;
  margin-top: -20px;
}
.form-control {
  margin-bottom: 0;
  height: 30px;
  color: black;
}
.menu {
  display: flex;
}
.menu form {
  display: flex;
  align-items: center;
}
.menu form .form-group {
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.menu form .form-group label {
  margin-right: 5px;
  white-space: nowrap;
  margin-bottom: 0;
}
.menu .btn-success {
  height: 40px;
}
.topbar {
  display: flex;
  justify-content: space-between;
  margin: 20px;
  align-items: center;
}
.topbar button {
  max-height: 2.3rem;
  border: 1px solid #ccc;
}
.topbar select {
  padding: 5px;
}
.toolbar {
  display: inline-block;
}
.toolbar a {
  padding: 4px 8px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  transition: background-color 0.2s;
  border-right: 1px solid #ccc;
}
.toolbar a:hover {
  cursor: pointer;
}
.toolbar a:first-child {
  border-radius: 4px 0 0 4px;
}
.toolbar a:last-child {
  border-radius: 0 4px 4px 0;
  border-right: none;
}
.toolbar a:hover {
  background-color: #0056b3;
}
.mat-checkbox {
  margin-left: 10px;
  padding-top: 6px;
}
::ng-deep .custom-select-padding .mat-mdc-form-field-infix {
  padding: 8px !important;
  min-height: 54px !important;
  align-content: center;
}
::ng-deep .mat-datepicker-content {
  background-color: #262933 !important;
  color: #ffffff !important;
}
::ng-deep .mat-calendar-table-header,
::ng-deep .mat-calendar-body-label {
  color: #a2a6b0 !important;
}
::ng-deep .mat-calendar-body-cell-content {
  color: #ffffff !important;
}
::ng-deep .mat-calendar-table-header-divider::after {
  background-color: #a2a6b0 !important;
}
::ng-deep .mat-calendar-arrow {
  border-top-color: #ffffff !important;
}
::ng-deep .mat-datepicker-toggle {
  color: #605959 !important;
}
::ng-deep .mat-calendar-previous-button,
::ng-deep .mat-calendar-next-button {
  color: #ffffff !important;
}
::ng-deep .custom-select-padding .mat-mdc-input-element {
  line-height: normal !important;
  padding-bottom: 5px !important;
  margin-top: 0px !important;
  width: 100%;
}
::ng-deep .custom-select-padding .mdc-notched-outline__leading,
::ng-deep .custom-select-padding .mdc-notched-outline__notch,
::ng-deep .custom-select-padding .mdc-notched-outline__trailing {
  border-color: #d9d9d9 !important;
}
/*# sourceMappingURL=adhoc-report.component.css.map */
